import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Page from '~/Components/Layout/Page/Page';

/**
 * Generic component to wrap page layouts and render a consistent layout across all pages of the site
 * Can also be used to create minimal container components that hook into Redux
 */
class Logout extends Component {
  componentDidMount = () => {
    this.props.fetchAll();
    this.props.handleLogout();
  };

  render() {
    return (
      <Page>
        <Redirect to="/login" />
      </Page>
    );
  }
}

Logout.propTypes = {
  fetchAll: PropTypes.func,
  handleLogout: PropTypes.func,
};

export default Logout;
